import React, { VoidFunctionComponent } from "react";
import { ServiceItem } from "./ServiceItem";

interface Props {
    type: string;
    icon: JSX.Element;
    children: JSX.Element;
    isGreyBackground?: boolean,
}

export const RenderSellerServiceItem: VoidFunctionComponent<Props> = ({ type, icon, children, isGreyBackground = false }) => {
    return (
        <ServiceItem
            icon={icon}
            serviceName={type}
            key={type}
            isGreyBackground={isGreyBackground}
        >
            {children}
        </ServiceItem>
    );
};

